/**
 * The words and time formats the alert list speaks, shared so the local and the cloud list
 * can't label the same row two different ways.
 */

/**
 * The human "alert name" = the matched alert-config's name. Rows that matched no config
 * (or predate one) fall back to a Title-Cased event type, which is what an operator would
 * call it anyway.
 */
export function alertName(a: any): string {
  if (a?.alert_config_name) return a.alert_config_name;
  const ev = a?.event_type || '';
  return ev ? ev.replace(/_/g, ' ').replace(/\b\w/g, (c: string) => c.toUpperCase()) : 'Alert';
}

/** Alert timestamps arrive as epoch SECONDS from the node, epoch ms from some callers. */
export function alertTimestampMs(ts: any): number {
  if (ts == null || ts === '') return NaN;
  let ms = Number(ts);
  if (!Number.isFinite(ms)) return new Date(ts).getTime();
  if (ms < 1e12) ms *= 1000;
  return ms;
}

/**
 * The list's "when" column, split in two: the clock reading on top and the day under it.
 *
 * Alerts are worked newest-first and almost always on the same day, so the time is the part
 * that distinguishes rows and the date is the part that only matters at the boundary — one
 * run-on `13/08/2026, 2:22:07 pm` per row made every row look identical at a glance.
 */
export function alertWhen(ts: any): { time: string; date: string; full: string } {
  const ms = alertTimestampMs(ts);
  if (Number.isNaN(ms)) return { time: '—', date: '', full: '' };
  const d = new Date(ms);
  return {
    time: d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' }).toLowerCase(),
    date: d.toLocaleDateString([], { day: '2-digit', month: 'short' }),
    full: d.toLocaleString(),
  };
}
